import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-return-key",
  "use": "icon-return-key-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-return-key\"><path d=\"M14.222 7.74V1h-2.074v6.74a1.037 1.037 0 0 1-1.037 1.038h-6.31l2.592-2.593-1.467-1.467L1.563 9.08a1.037 1.037 0 0 0 0 1.468l4.363 4.363 1.467-1.468-2.592-2.592h6.31a3.11 3.11 0 0 0 3.111-3.111\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol